
import { defineComponent } from 'vue'
import { iconDefaultProps } from './defaultProps'

export default defineComponent({
  name: 'IconFile',
  props: { ...iconDefaultProps },
})
